import React from "react";
import classes from "./MainFooter.module.css";
import MainFooterProduct from "./MainFooterProduct";
import MainFooterContactus from "./MainFooterContactus";
import MainFooterUsefulLink from "./MainFooterUsefulLink";
import MainFoooterAbout from "./MainFoooterAbout";

const MainFooter = () => {
  return (
    <footer className={classes["main-footer-container"]}>
      <MainFoooterAbout />
      <MainFooterUsefulLink />
      <MainFooterContactus />
      {/* <MainFooterProduct /> */}
    </footer>
  );
};
export default MainFooter;
